import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchCategorynData = createAsyncThunk("api/category", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-category-list/`);
  const data = await response.json();
  return data;
});

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categorydata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategorynData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategorynData.fulfilled, (state, action) => {
        state.loading = false;
        state.categorydata = action.payload;
      })
      .addCase(fetchCategorynData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default categorySlice.reducer;
